var hdr=document.getElementById('hdr');
  function onScroll(){ if(window.scrollY>40){ hdr.classList.add('solid'); } else { hdr.classList.remove('solid'); } }
  window.addEventListener('scroll', onScroll); onScroll();

  // word-by-word splitter (keeps .serif spans as one unit)
  function splitWords(el){
    var parts=[];
    el.childNodes.forEach(function(n){
      if(n.nodeType===3){ n.textContent.split(/\s+/).forEach(function(w){ if(w) parts.push({t:w,s:false}); }); }
      else if(n.nodeType===1){ parts.push({t:n.textContent,s:true}); }
    });
    el.innerHTML=parts.map(function(p,i){
      var inner=p.s?'<span class="serif">'+p.t+'</span>':p.t;
      return '<span class="w" style="--d:'+(i*0.07).toFixed(2)+'s">'+inner+'</span>';
    }).join(' ');
  }
  document.querySelectorAll('.wsplit').forEach(splitWords);

  // hero title plays on load; everything else on scroll
  var heroT=document.getElementById('heroTitle');
  setTimeout(function(){ if(heroT) heroT.classList.add('in'); }, 250);

  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } }); }, {threshold:0.25});
    document.querySelectorAll('.rv, .wsplit:not(#heroTitle)').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.rv, .wsplit').forEach(function(el){ el.classList.add('in'); });
  }

  // count-up on reveal
  var numsSec=document.querySelector('.nums');
  if(numsSec && 'IntersectionObserver' in window){
    var nio=new IntersectionObserver(function(es){ es.forEach(function(en){ if(!en.isIntersecting) return; nio.disconnect();
      document.querySelectorAll('[data-count]').forEach(function(el){
        var target=parseInt(el.dataset.count,10), t0=null;
        function step(t){ if(!t0)t0=t; var p=Math.min((t-t0)/1300,1); var e=1-Math.pow(1-p,4); el.textContent=Math.round(target*e); if(p<1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
    }); }, {threshold:0.4});
    nio.observe(numsSec);
  }

  // hero sub-line follows the title
  setTimeout(function(){ document.querySelectorAll('.hero .rv').forEach(function(el){ el.classList.add('in'); }); }, 1100);

  // soft page transitions for internal links
  (function(){
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.addEventListener('click', function(e){
      var a=e.target.closest('a'); if(!a) return;
      var href=a.getAttribute('href');
      if(!href || href.charAt(0)==='#' || a.target==='_blank') return;
      var _u;try{_u=new URL(a.href,location.href);}catch(_e){return;}if(_u.origin!==location.origin||_u.pathname===location.pathname)return;
      e.preventDefault();
      document.body.classList.add('leaving');
      setTimeout(function(){ window.location.href=a.href; }, 300);
    });
    window.addEventListener('pageshow', function(){ document.body.classList.remove('leaving'); });
  })();;
(function(){
    var d=document.getElementById('anrayCart'); if(!d) return;
    var body=document.getElementById('acBody'), sub=document.getElementById('acSub');
    var cart=null, pending={}, inflight=false, dirty=false;
    function money(c){ c=Number(c); if(!isFinite(c)) c=0; return '$'+(c/100).toFixed(2); }
    function valid(c){ return !!(c && c.items && c.items.map && typeof c.total_price==='number'); }
    function hasPending(){ for(var k in pending){ if(pending.hasOwnProperty(k)) return true; } return false; }
    function setCount(n){ document.querySelectorAll('.navcart .cartcount').forEach(function(b){ b.textContent=' ('+n+')'; if(n>0){ b.removeAttribute('data-empty'); } else { b.setAttribute('data-empty',''); } }); }
    function recalc(){ var t=0,n=0; var pd=Number(cart.total_discount)||0; var ps=(Number(cart.total_price)||0)+pd; cart.items.forEach(function(i){ var u=Number(i.final_price||i.price)||0; i.final_line_price=u*i.quantity; t+=i.final_line_price; n+=i.quantity; }); var nd=(pd>0&&ps>0)?Math.round(t*pd/ps):0; cart.total_discount=nd; cart.total_price=t-nd; cart.item_count=n; }
    function render(){
      if(!cart||!cart.items.length){ body.innerHTML='<p class="acempty">'+(document.body.classList.contains('zh')?'购物车是空的。':'Your cart is empty.')+'</p>'; }
      else{ body.innerHTML=cart.items.map(function(i){
        var img=i.image?'<img src="'+i.image+'" alt="'+i.product_title+'">':'<div class="acnoimg"></div>';
        return '<div class="acitem" data-key="'+i.key+'">'+img+'<div class="acmeta"><div class="acname">'+i.product_title+'</div>'+(i.variant_title?'<div class="acvar">'+i.variant_title+'</div>':'')+'<div class="acrow"><span class="acqty"><button type="button" class="acstep" data-d="-1">&minus;</button><b>'+i.quantity+'</b><button type="button" class="acstep" data-d="1">+</button></span><span class="acprice">'+money(i.final_line_price)+'</span></div></div><button type="button" class="acremove" aria-label="Remove">&times;</button></div>';
      }).join(''); }
      sub.textContent=money(cart?cart.total_price:0); setCount(cart?cart.item_count:0); discountUI();
    }
    function adopt(c){ if(valid(c)&&!hasPending()){ cart=c; render(); } }
    function refresh(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ adopt(c); return c; }).catch(function(){ return null; }); }
    function flush(){
      if(inflight) return;
      var k=null; for(var key in pending){ if(pending.hasOwnProperty(key)){ k=key; break; } }
      if(k===null){
        if(dirty){ dirty=false; inflight=true;
          fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ inflight=false; adopt(c); flush(); }).catch(function(){ inflight=false; });
        }
        return;
      }
      var q=pending[k]; delete pending[k]; inflight=true; dirty=true;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:k,quantity:q})})
        .then(function(r){ return r.json().catch(function(){ return null; }); })
        .then(function(){ inflight=false; flush(); })
        .catch(function(){ inflight=false; flush(); });
    }
    function localSet(key,q){
      if(!cart) return;
      var it=null; cart.items.forEach(function(i){ if(i.key===key) it=i; });
      if(!it) return;
      if(q<1){ cart.items=cart.items.filter(function(i){ return i.key!==key; }); q=0; }
      else{ it.quantity=q; }
      recalc(); render();
      pending[key]=q; flush();
    }
    function openD(){ d.classList.add('on'); d.setAttribute('aria-hidden','false'); }
    function closeD(){ d.classList.remove('on'); d.setAttribute('aria-hidden','true'); }
    d.querySelector('.acmask').addEventListener('click', closeD);
    d.querySelector('.acclose').addEventListener('click', closeD);
    body.addEventListener('click', function(e){
      var b=e.target.closest('button'); if(!b) return;
      var item=b.closest('.acitem'); if(!item||!cart) return;
      var key=item.getAttribute('data-key');
      var it=null; cart.items.forEach(function(i){ if(i.key===key) it=i; });
      if(!it) return;
      if(b.classList.contains('acremove')){ localSet(key,0); }
      else if(b.classList.contains('acstep')){ localSet(key, it.quantity+parseInt(b.getAttribute('data-d'),10)); }
    });
    document.querySelectorAll('.navcart').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); refresh().then(openD); }); });
    function variant(){ var p=document.querySelector('#buyOpts .opt[aria-pressed="true"][data-variant]')||document.querySelector('#buyOpts .opt[data-variant]'); return p?p.getAttribute('data-variant'):null; }
    function add(btn){ var id=variant(); if(!id) return; var t=btn.textContent; btn.style.pointerEvents='none'; if(btn.id==='addBtn'){ btn.textContent=document.body.classList.contains('zh')?'加入中\u2026':'Adding\u2026'; }
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
        .then(function(r){ return r.json().catch(function(){ return null; }); })
        .then(function(){ return refresh(); })
        .then(function(){ openD(); btn.style.pointerEvents=''; btn.textContent=t; })
        .catch(function(){ btn.style.pointerEvents=''; btn.textContent=t; });
    }
    var ab=document.getElementById('addBtn'); if(ab){ ab.addEventListener('click', function(e){ e.preventDefault(); add(this); }); }
    var bb=document.getElementById('navBuy'); if(bb){ bb.addEventListener('click', function(e){ e.preventDefault(); add(this); }); }
    var discCode=null;
    function zhMode(){ return document.body.classList.contains('zh'); }
    function discountUI(){
      var row=document.getElementById('acDiscRow'), amt=document.getElementById('acDiscAmt'), lab=document.getElementById('acDiscLabel'), inp=document.getElementById('acDiscIn');
      if(!row) return;
      if(inp){ inp.placeholder = zhMode()?'\u8f93\u5165\u4f18\u60e0\u7801':'Discount code'; }
      var d=cart?(Number(cart.total_discount)||0):0;
      if(cart&&cart.discount_codes&&cart.discount_codes.length){ var ap=null; cart.discount_codes.forEach(function(x){ if(x&&x.code&&x.applicable!==false){ ap=ap||x.code; } }); if(ap){ discCode=ap; } }
      if(d>0){ lab.textContent=(zhMode()?'\u4f18\u60e0':'Discount')+(discCode?' \u00b7 '+discCode:''); amt.textContent='\u2212'+money(d); row.style.display='flex'; }
      else{ row.style.display='none'; }
    }
    function discMsg(t){ var m=document.getElementById('acDiscMsg'); if(!m) return; if(t){ m.textContent=t; m.style.display='block'; } else { m.style.display='none'; } }
    function setDiscount(code, after){
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:code})})
        .then(function(r){ return r.json().catch(function(){ return null; }); })
        .then(function(c){ after(valid(c)?c:null); })
        .catch(function(){ after(null); });
    }
    var db=document.getElementById('acDiscBtn');
    if(db) db.addEventListener('click', function(){
      var inp=document.getElementById('acDiscIn'); var code=(inp.value||'').trim(); if(!code) return;
      db.style.pointerEvents='none'; discMsg(null); inp.classList.remove('err');
      setDiscount(code, function(c){
        if(c && Number(c.total_discount)>0){ discCode=code.toUpperCase(); cart=c; inp.value=''; render(); }
        else{ setDiscount('', function(c2){ if(c2){ cart=c2; render(); } }); inp.classList.add('err'); discMsg(zhMode()?'\u8be5\u4f18\u60e0\u7801\u65e0\u6548\u6216\u4e0d\u9002\u7528':'This code is invalid or not applicable.'); }
        db.style.pointerEvents='';
      });
    });
    var di=document.getElementById('acDiscIn');
    if(di) di.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); if(db) db.click(); } });
    var dr=document.getElementById('acDiscRm');
    if(dr) dr.addEventListener('click', function(){ setDiscount('', function(c){ discCode=null; if(c){ cart=c; render(); } else { refresh(); } }); });

    refresh();
  })();
